// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { FC } from "react";
import CartBanner from "@store/Library/Components/CartBanner";
import { useCurrentCartState } from "@toolkit/Framework/Store/Data/Carts/CartsHooks";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";
import isCreditCardOnlyCustomer from "@store/Framework/Common/Utilities/isCreditCardOnlyCustomer";
import siteMessage from "@insite/client-framework/SiteMessage";

const MinimumOrderAmountBanner: FC<WidgetProps> = props => {
    const cartDataView = useCurrentCartState().value;

    if (!cartDataView) {
        return null;
    }

    const isEligibleToPlaceOrder = getBooleanProperty(cartDataView.properties.isEligibleToPlaceOrder);
    const remainingAmountDisplay = cartDataView.properties.remainingToOrderMinimumDisplay;
    const orderMinimumDisplay = cartDataView.properties.orderMinimumDisplay;
    const showMinimumOrderAmountBanner =
        !isEligibleToPlaceOrder && remainingAmountDisplay !== undefined && orderMinimumDisplay !== undefined;

    const isPaymentCreditCardOnly = isCreditCardOnlyCustomer(cartDataView);
    const isEligibleForFreeShipping = getBooleanProperty(cartDataView.properties.isEligibleForFreeShipping);
    const remainingToFreeShippingDisplay = cartDataView.properties.remainingToFreeShippingDisplay;
    const showCreditCardBanner =
        isPaymentCreditCardOnly &&
        isEligibleToPlaceOrder &&
        !isEligibleForFreeShipping &&
        remainingToFreeShippingDisplay !== undefined;

    if (!showMinimumOrderAmountBanner && !showCreditCardBanner) {
        return null;
    }

    return (
        <>
            {showMinimumOrderAmountBanner && (
                <CartBanner
                    label={siteMessage(
                        "Cart_MinimumOrderAmountBanner",
                        remainingAmountDisplay,
                        orderMinimumDisplay,
                    ).toString()}
                    variant="warning"
                />
            )}
            {showCreditCardBanner && (
                <CartBanner
                    label={siteMessage(
                        "Cart_CreditCardMinimumOrderAmountBanner",
                        remainingToFreeShippingDisplay,
                    ).toString()}
                    variant="warning"
                />
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: MinimumOrderAmountBanner,
    definition: {
        group: "Common",
        displayName: "Minimum Order Amount Banner",
        allowedContexts: ["CartPage"],
    },
};

export default widgetModule;
